document.addEventListener("click", event => {
  const thumb = event.target.closest("[data-gallery-src]");
  if (!thumb) return;
  const section = thumb.closest("[data-product-section]");
  const hero = section.querySelector(".main-image img");
  hero.removeAttribute("srcset");
  hero.src = thumb.dataset.gallerySrc;
  hero.alt = thumb.querySelector("img").alt;
  section.querySelectorAll(".thumb").forEach(t => t.setAttribute("aria-pressed", String(t === thumb)));
});

document.addEventListener("change", event => {
  if (!event.target.matches("[data-variant]")) return;
  const section = event.target.closest("[data-product-section]");
  const option = event.target.selectedOptions[0];
  section.querySelector("[data-price]").textContent = option.dataset.price;
  const button = section.querySelector("[data-add]");
  button.disabled = option.dataset.available !== "true";
  button.textContent = button.disabled ? "Udsolgt" : "Læg i kurven";
});

document.addEventListener("change", event => {
  if (!event.target.matches("[data-variant]")) return;
  const image = event.target.selectedOptions[0].dataset.image;
  if (image) {
    const hero = event.target.closest("[data-product-section]").querySelector(".main-image img");
    hero.removeAttribute("srcset");
    hero.src = image;
  }
});

(function() {
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  function initMarquee(box) {
    if (box.__marquee) {
      box.__marquee();
      return;
    }
    var track = box.querySelector(".media-marquee__track");
    var sets = track ? track.querySelectorAll(".media-marquee__set") : [];
    if (!track || sets.length < 2) return;
    var timer;
    function measure() {
      var forced = box.hasAttribute("data-force-motion");
      if (reduce.matches && !forced) {
        track.style.removeProperty("--marquee-shift");
        track.style.removeProperty("--marquee-duration");
        return;
      }
      var gap = parseFloat(getComputedStyle(track).gap) || 16;
      var setWidth = sets[0].getBoundingClientRect().width + gap;
      if (!setWidth) return;
      var needed = Math.max(2, Math.ceil(box.clientWidth / setWidth) + 1);
      while (track.children.length < needed) track.appendChild(sets[1].cloneNode(true));
      var speed = parseFloat(box.dataset.speed) || 45;
      track.style.setProperty("--marquee-shift", -setWidth + "px");
      track.style.setProperty("--marquee-duration", setWidth / speed + "s");
      track.style.setProperty("--marquee-direction", box.dataset.direction === "right" ? "reverse" : "normal");
    }
    box.__marquee = measure;
    measure();
    window.addEventListener("resize", function() {
      clearTimeout(timer);
      timer = setTimeout(measure, 150);
    });
    if (reduce.addEventListener) reduce.addEventListener("change", measure);
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          box.classList.toggle("is-paused", !e.isIntersecting);
        });
      }, {
        rootMargin: "120px"
      }).observe(box);
    }
  }
  function initAll(root) {
    (root || document).querySelectorAll("[data-marquee]").forEach(initMarquee);
  }
  initAll();
  document.addEventListener("shopify:section:load", function(e) {
    initAll(e.target);
  });
})();

(function() {
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  function play(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function() {});
  }
  function initVideo(v) {
    if (v.__autoplay) return;
    v.__autoplay = true;
    var card = v.closest("[data-video-card]");
    var section = v.closest("[data-video-section]");
    var btn = card ? card.querySelector("[data-video-sound]") : null;
    v.muted = true;
    v.defaultMuted = true;
    if (btn) {
      btn.addEventListener("click", function(ev) {
        ev.stopPropagation();
        v.muted = !v.muted;
        btn.setAttribute("aria-pressed", String(!v.muted));
        btn.setAttribute("aria-label", v.muted ? "Lyd til" : "Lyd fra");
        if (v.paused) {
          play(v);
          if (card) card.classList.remove("is-paused");
        }
      });
    }
    v.addEventListener("click", function() {
      if (v.paused) {
        play(v);
      } else {
        v.pause();
      }
      if (card) card.classList.toggle("is-paused", v.paused);
    });
    var forced = !!(section && section.hasAttribute("data-force-motion"));
    if (reduce.matches && !forced) {
      v.removeAttribute("autoplay");
      v.pause();
      if (card) card.classList.add("is-paused");
      return;
    }
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          var userPaused = !!(card && card.classList.contains("is-paused"));
          if (e.isIntersecting) {
            if (!userPaused) play(v);
          } else {
            v.pause();
          }
        });
      }, {
        threshold: .35
      }).observe(v);
    } else {
      play(v);
    }
  }
  function initAll(root) {
    (root || document).querySelectorAll("[data-autoplay-video]").forEach(initVideo);
  }
  function armLazyVideos(root) {
    (root || document).querySelectorAll("video source[data-src]").forEach(function(s) {
      var v = s.parentNode;
      function load() {
        if (s.getAttribute("src")) return;
        s.setAttribute("src", s.getAttribute("data-src"));
        v.setAttribute("preload", "metadata");
        v.load();
        window.removeEventListener("scroll", onScroll);
        window.removeEventListener("resize", onScroll);
      }
      var near = function() {
        return v.getBoundingClientRect().top <= window.innerHeight + 500;
      };
      var onScroll = function() {
        if (near()) {
          load();
        }
      };
      var arm = function() {
        if (near()) {
          load();
          return;
        }
        window.addEventListener("scroll", onScroll, {
          passive: true
        });
        window.addEventListener("resize", onScroll, {
          passive: true
        });
        if ("IntersectionObserver" in window) {
          var io = new IntersectionObserver(function(entries) {
            entries.forEach(function(e) {
              if (e.isIntersecting && near()) {
                load();
                io.disconnect();
              }
            });
          }, {
            rootMargin: "500px"
          });
          io.observe(v);
        }
      };
      if (document.readyState === "complete") {
        setTimeout(arm, 0);
      } else {
        window.addEventListener("load", function() {
          setTimeout(arm, 0);
        });
      }
    });
  }
  armLazyVideos();
  document.addEventListener("shopify:section:load", function(e) {
    armLazyVideos(e.target);
  });
  initAll();
  document.addEventListener("shopify:section:load", function(e) {
    initAll(e.target);
  });
})();

(function() {
  var root = document.documentElement.getAttribute("data-root") || "/";
  var lastFocus = null;
  function fetchJSON(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({
      Accept: "application/json"
    }, opts.headers || {});
    return fetch(url, opts).then(function(r) {
      return r.json().then(function(d) {
        if (!r.ok) throw new Error(d.description || d.message || "Noget gik galt. Prøv igen.");
        return d;
      });
    });
  }
  function updateCount(n) {
    document.querySelectorAll("[data-cart-count]").forEach(function(el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute("data-empty"); else el.setAttribute("data-empty", "");
    });
  }
  function announce(message) {
    var el = document.querySelector("[data-cart-live]");
    if (!el) return;
    el.textContent = "";
    setTimeout(function() {
      el.textContent = message;
    }, 60);
  }
  function drawer() {
    return document.getElementById("CartDrawer");
  }
  function showError(container, message) {
    if (!container) return;
    var old = container.querySelector(".form-error");
    if (old) old.remove();
    var p = document.createElement("p");
    p.className = "form-error";
    p.setAttribute("role", "alert");
    p.textContent = message;
    container.insertAdjacentElement("afterbegin", p);
  }
  function refresh(open, message) {
    var ids = [ "cart-drawer" ];
    var page = document.querySelector("[data-cart-page]");
    if (page && page.dataset.sectionId) ids.push(page.dataset.sectionId);
    return fetch(location.pathname + "?sections=" + ids.join(",")).then(function(r) {
      return r.json();
    }).then(function(sections) {
      var html = sections["cart-drawer"];
      var count = null;
      if (html) {
        var doc = (new DOMParser).parseFromString(html, "text/html");
        var fresh = doc.getElementById("CartDrawer");
        var old = drawer();
        if (fresh && old) {
          old.replaceWith(fresh);
          count = parseInt(fresh.dataset.cartItems, 10) || 0;
          updateCount(count);
        }
      }
      if (page && sections[page.dataset.sectionId]) {
        var pdoc = (new DOMParser).parseFromString(sections[page.dataset.sectionId], "text/html");
        var pfresh = pdoc.querySelector("[data-cart-page]");
        if (pfresh) page.replaceWith(pfresh);
        var upd = document.querySelector("[data-cart-update]");
        if (upd) upd.hidden = true;
      }
      if (message && count !== null) announce(message + " Der er nu " + count + (count === 1 ? " vare i kurven." : " varer i kurven."));
      if (open) openDrawer();
    }).catch(function() {});
  }
  function openDrawer() {
    var d = drawer();
    if (!d) return;
    lastFocus = document.activeElement;
    document.body.classList.add("cart-open");
    var panel = d.querySelector(".cart-drawer__panel");
    if (panel) setTimeout(function() {
      panel.focus();
    }, 50);
  }
  function closeDrawer() {
    if (!document.body.classList.contains("cart-open")) return;
    document.body.classList.remove("cart-open");
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape") {
      closeDrawer();
      return;
    }
    if (e.key !== "Tab" || !document.body.classList.contains("cart-open")) return;
    var d = drawer();
    var panel = d && d.querySelector(".cart-drawer__panel");
    if (!panel) return;
    var f = panel.querySelectorAll('a[href]:not([tabindex="-1"]),button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], active = document.activeElement;
    if (e.shiftKey && (active === first || active === panel)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (active === last || !panel.contains(active))) {
      e.preventDefault();
      first.focus();
    }
  });
  document.addEventListener("click", function(e) {
    if (e.target.closest("[data-cart-close]")) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    var opener = e.target.closest("[data-open-cart]");
    if (opener && drawer()) {
      e.preventDefault();
      openDrawer();
      refresh(false);
      return;
    }
    var step = e.target.closest("[data-qty-change]");
    if (step) {
      var line = step.closest("[data-line]");
      var input = line.querySelector("[data-qty-input]");
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.qtyChange, 10));
      input.value = next;
      changeLine(line, next);
      return;
    }
    var remove = e.target.closest("[data-line-remove]");
    if (remove) {
      e.preventDefault();
      changeLine(remove.closest("[data-line]"), 0);
      return;
    }
  });
  document.addEventListener("change", function(e) {
    var input = e.target.closest("[data-qty-input]");
    if (!input) return;
    changeLine(input.closest("[data-line]"), Math.max(0, parseInt(input.value, 10) || 0));
  });
  function changeLine(line, quantity) {
    if (!line) return;
    var container = line.closest(".cart-drawer__body") || line.closest("[data-cart-page]");
    line.style.opacity = ".5";
    fetchJSON(root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        line: parseInt(line.dataset.line, 10),
        quantity: quantity
      })
    }).then(function() {
      return refresh(false, quantity === 0 ? "Vare fjernet." : "Antal opdateret.");
    }).catch(function(err) {
      refresh(false).then(function() {
        var c = container && container.classList.contains("cart-drawer__body") ? drawer().querySelector(".cart-drawer__body") : document.querySelector("[data-cart-page]");
        showError(c, err.message);
      });
    });
  }
  document.addEventListener("submit", function(e) {
    var form = e.target.closest("form.product-form");
    if (!form || !drawer()) return;
    e.preventDefault();
    var btn = form.querySelector("[data-add]");
    var old = form.querySelector(".form-error");
    if (old) old.remove();
    var label = btn ? btn.textContent : "";
    if (btn) {
      btn.dataset.state = "busy";
      btn.textContent = "Lægger i kurven…";
    }
    fetchJSON(root + "cart/add.js", {
      method: "POST",
      body: new FormData(form)
    }).then(function() {
      if (btn) {
        btn.dataset.state = "done";
        btn.textContent = "Lagt i kurven ✓";
        setTimeout(function() {
          btn.textContent = label;
          delete btn.dataset.state;
        }, 1600);
      }
      return refresh(true, "Lagt i kurven.");
    }).catch(function(err) {
      if (btn) {
        btn.textContent = label;
        delete btn.dataset.state;
      }
      var p = document.createElement("p");
      p.className = "form-error";
      p.setAttribute("role", "alert");
      p.textContent = err.message;
      (btn || form).insertAdjacentElement("afterend", p);
    });
  });
  var upd = document.querySelector("[data-cart-update]");
  if (upd) upd.hidden = true;
  updateCount(parseInt((drawer() || {
    dataset: {}
  }).dataset.cartItems || "0", 10));
})();

(function() {
  document.addEventListener("change", function(event) {
    var input = event.target.closest("[data-offer]");
    if (!input) return;
    var section = input.closest("[data-product-section]");
    if (!section) return;
    section.querySelectorAll(".offer").forEach(function(l) {
      l.classList.toggle("is-selected", l.contains(input));
    });
    var price = section.querySelector("[data-price]");
    if (price) price.textContent = input.dataset.price;
    var cmp = section.querySelector("[data-compare]");
    if (cmp) {
      if (input.dataset.compare) {
        cmp.textContent = input.dataset.compare;
        cmp.hidden = false;
      } else {
        cmp.textContent = "";
        cmp.hidden = true;
      }
    }
    var button = section.querySelector("[data-add]");
    if (button) {
      button.disabled = input.dataset.available !== "true";
      button.textContent = button.disabled ? "Udsolgt" : "Læg i kurven";
    }
    if (input.dataset.image) {
      var hero = section.querySelector(".main-image img");
      if (hero) {
        var base = input.dataset.image;
        hero.src = base;
        hero.srcset = [ 500, 800, 1100, 1400 ].map(function(w) {
          return base.replace(/([?&])width=\d+/, "$1width=" + w) + " " + w + "w";
        }).join(", ");
        if (input.dataset.alt) hero.alt = input.dataset.alt;
      }
    }
  });
  document.addEventListener("change", function(event) {
    if (!event.target.matches("[data-variant]")) return;
    var section = event.target.closest("[data-product-section]");
    var option = event.target.selectedOptions[0];
    var cmp = section && section.querySelector("[data-compare]");
    if (cmp) {
      if (option.dataset.compare) {
        cmp.textContent = option.dataset.compare;
        cmp.hidden = false;
      } else {
        cmp.textContent = "";
        cmp.hidden = true;
      }
    }
  });
})();

(function() {
  var el = document.querySelector("[data-cutoff]");
  if (!el) return;
  var parts = (el.dataset.cutoff || "16:00").split(":");
  var hh = parseInt(parts[0], 10) || 16, mm = parseInt(parts[1], 10) || 0;
  var left = el.querySelector("[data-cutoff-left]"), day = el.querySelector("[data-cutoff-day]");
  function pad(n) {
    return String(n).padStart(2, "0");
  }
  var DAGEN = [ "søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag" ];
  var FEEST = [ "2026-12-24", "2026-12-25", "2026-12-26", "2027-01-01", "2027-03-25", "2027-03-26", "2027-03-29", "2027-05-06", "2027-05-17", "2027-12-24", "2027-12-25", "2027-12-26", "2028-01-01" ];
  function iso(d) {
    return d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate());
  }
  function tick() {
    var now = new Date;
    var target = new Date(now);
    target.setHours(hh, mm, 0, 0);
    if (target <= now) {
      target.setDate(target.getDate() + 1);
    }
    while (target.getDay() === 0 || target.getDay() === 6 || FEEST.indexOf(iso(target)) >= 0) {
      target.setDate(target.getDate() + 1);
    }
    var d = target - now;
    var h = Math.floor(d / 36e5), m = Math.floor(d % 36e5 / 6e4), s = Math.floor(d % 6e4 / 1e3);
    if (left) left.textContent = pad(h) + ":" + pad(m) + ":" + pad(s);
    if (day) {
      var diff = Math.round((new Date(target.getFullYear(), target.getMonth(), target.getDate()) - new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 864e5);
      day.textContent = diff === 0 ? "i dag" : diff === 1 ? "i morgen" : DAGEN[target.getDay()];
    }
  }
  tick();
  setInterval(tick, 1e3);
})();

(function() {
  var bar = document.querySelector("[data-announcement]");
  if (!bar) return;
  var items = bar.querySelectorAll(".announcement__item");
  if (items.length < 2) return;
  var i = 0, timer = null, interval = (parseInt(bar.dataset.interval, 10) || 4) * 1e3;
  function show(n) {
    i = (n + items.length) % items.length;
    items.forEach(function(it, k) {
      it.classList.toggle("is-active", k === i);
    });
  }
  function start() {
    stop();
    timer = setInterval(function() {
      show(i + 1);
    }, interval);
  }
  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }
  var prev = bar.querySelector("[data-announcement-prev]"), next = bar.querySelector("[data-announcement-next]");
  if (prev) prev.addEventListener("click", function() {
    show(i - 1);
    start();
  });
  if (next) next.addEventListener("click", function() {
    show(i + 1);
    start();
  });
  bar.addEventListener("mouseenter", stop);
  bar.addEventListener("mouseleave", start);
  bar.addEventListener("focusin", stop);
  bar.addEventListener("focusout", start);
  start();
})();

(function() {
  document.addEventListener("change", function(e) {
    var input = e.target.closest("[data-color-choice]");
    if (!input) return;
    var section = input.closest("[data-product-section]");
    if (!section) return;
    section.querySelectorAll(".swatch").forEach(function(l) {
      l.classList.toggle("is-selected", l.contains(input));
    });
    var name = section.querySelector("[data-color-name]");
    if (name) name.textContent = input.value;
    var mapEl = section.querySelector("[data-variant-map]");
    if (!mapEl) return;
    var map = [];
    try {
      map = JSON.parse(mapEl.textContent);
    } catch (err) {
      return;
    }
    section.querySelectorAll(".offer[data-pack]").forEach(function(card) {
      var v = null;
      for (var n = 0; n < map.length; n++) {
        if (map[n].pack === card.dataset.pack && map[n].color === input.value) {
          v = map[n];
          break;
        }
      }
      if (!v) return;
      var radio = card.querySelector("[data-offer]");
      if (!radio) return;
      radio.value = v.id;
      radio.dataset.price = v.price;
      radio.dataset.compare = v.compare || "";
      radio.dataset.available = String(v.available);
      if (v.image) {
        radio.dataset.image = v.image;
        radio.dataset.alt = v.alt || "";
      } else {
        delete radio.dataset.image;
        delete radio.dataset.alt;
      }
      radio.disabled = !v.available;
      card.classList.toggle("is-unavailable", !v.available);
      var p = card.querySelector("[data-offer-price]");
      if (p) p.textContent = v.price;
      var c = card.querySelector("[data-offer-compare]");
      if (c) {
        c.textContent = v.compare || "";
        c.hidden = !v.compare;
      }
      var b = card.querySelector("[data-offer-badge]");
      if (b) {
        b.textContent = "-" + v.pct + "%";
        b.hidden = !v.pct;
      }
      var note = card.querySelector("[data-offer-note]");
      if (note) note.hidden = v.available;
    });
    var checked = section.querySelector("[data-offer]:checked");
    if (checked && checked.disabled) {
      var alt = section.querySelector("[data-offer]:not(:disabled)");
      if (alt) {
        alt.checked = true;
        checked = alt;
      }
    }
    if (checked) checked.dispatchEvent(new Event("change", {
      bubbles: true
    }));
  });
})();

(function() {
  var form = document.querySelector("[data-tracking-form]");
  if (!form) return;
  form.addEventListener("submit", function(e) {
    var pattern = form.dataset.pattern || "";
    var field = form.querySelector("[name=nr]");
    var code = field ? field.value.trim() : "";
    if (!pattern || pattern.indexOf("{code}") < 0 || !code) return;
    e.preventDefault();
    window.open(pattern.replace("{code}", encodeURIComponent(code)), "_blank", "noopener");
  });
})();

(function() {
  var s = document.querySelector("[data-reviews]");
  if (!s) return;
  var b = s.querySelector("[data-reviews-more]");
  if (!b) return;
  b.addEventListener("click", function() {
    s.classList.add("is-open");
    var first = s.querySelector(".review--hidden");
    if (first && first.scrollIntoView) {
      first.scrollIntoView({
        block: "nearest"
      });
    }
  });
})();
